import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'my-task',
    pathMatch: 'full'
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.module').then(m => m.AppointmentsModule)
  },
  {
    path: 'membership',
    loadChildren: () => import('./membership/membership.module').then(m => m.MembershipModule)
  },
  {
    path: 'my-task',
    loadChildren: () => import('./my-task/my-task.module').then(m => m.MyTaskModule)
  },
  {
    path: 'hr-management',
    loadChildren: () => import('./hr-management/hr-management.module').then(m => m.HrManagementModule)
  },
  {
    path: 'patients',
    loadChildren: () => import('./patients/patients.module').then(m => m.PatientsModule)
  },
  {
    path: 'configurations',
    loadChildren: () => import('./configurations/configurations.module').then(m => m.ConfigurationsModule)
  },
  {
    path: 'referrals',
    loadChildren: () => import('./refferals/refferals.module').then(m => m.RefferalsModule)
  },
  {
    path: 'email',
    loadChildren: () => import('./email/email.module').then(m => m.EmailModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'compliance',
    loadChildren: () => import('./compliance/compliance.module').then(m => m.ComplianceModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
